"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarWeek = void 0;

var _styledComponents = require("styled-components");

var CalendarWeek = (0, _styledComponents.css)(["", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && ".react-datepicker__week {\n      display: flex;\n      justify-content: center;\n    }";
});
exports.CalendarWeek = CalendarWeek;